import React from 'react';

import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

// Scss
import styles from './DeleteConfirmation.module.scss';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteConfirmation = ({ showModal, title, message, handleCancelClick, handleSubmitClick, btn1_title,  btn2_title}) => {
    return (
        <React.Fragment>
            <Dialog
                open={showModal}
                TransitionComponent={Transition}
                onClose={handleCancelClick}
                classes={{
                    paper: styles.modalDialog
                }}
                aria-labelledby="modal-slide-title"
                aria-describedby="modal-slide-description"
            >
                <DialogContent
                    className={styles.modalContent}
                >
                    <div className={`text-center ${styles.modalBody}`}>
                        <h5 className={`my-3 text-center ${styles.modalTitle}`}>{title}</h5>
                        <p className={`popup-info-text ${styles.modalMessage}`}> {message} </p>
                        <span data-dismiss="modal" onClick={handleSubmitClick} className="btn gray-btn d-inline-block mb-3 mr-2"> {btn1_title ? btn1_title : "Delete"} </span>
                        <span data-dismiss="modal" onClick={handleCancelClick} className="btn gray-btn d-inline-block mb-3"> {btn2_title ? btn2_title : "Cancel"} </span>
                    </div>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}

export default DeleteConfirmation;
